import {Control, MousePosition} from "ol/control";
import {createStringXY} from "ol/coordinate";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper.js";

export class MousePositionControl extends MousePosition {
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
        super({
            coordinateFormat: createStringXY(),
            projection: getViewProjectionName(),
            // comment the following two lines to have the mouse position
            // be placed within the map.
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
        });
    }
}
